<template>
  <div class="bankeys">
    <Header :logo="logo" :title="title" :menu="isBankeys" :quick="isBankeys" />
    <div class="main-wrapper">
      <div class="scroll-content" ref="scrollContent">
        <router-view :appInfo="appInfo" :isResale="isResale"></router-view>
        <Footer />
      </div>
    </div>
    <Ask :user="user" :scrollContent="() => $refs.scrollContent" />
  </div>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'
import Ask from '@/components/Ask'
import { mapActions } from 'vuex'
// 天眼
import '@/plugins/skyeye'
import '@/plugins/element'

export default {
  components: { Header, Footer, Ask },
  data() {
    return {
      user: {},
      logo: '',
      appInfo: {},
    }
  },
  computed: {
    isBankeys() {
      return !!(this.$route.query.ditchID || this.$route.query.tsign_source_type || this.$route.query.tsign_source_detail)
    },
    isResale() {
      const {
        query: { isResale },
      } = this.$route

      return isResale === '1'
    },
    title() {
      return this.isBankeys ? (this.isResale ? '专属印章申领' : '专属印章购买') : null
    },
  },
  async created() {
    if (this.isBankeys) {
      this.getAPPInfo()
      this.user = await this.getUserInfoForBankey()
      this.trackPage()
    }
  },
  methods: {
    ...mapActions('user', ['getUserInfoForBankey']),
    // 获取应用配置信息以及应用名称描述
    async getAPPInfo() {
      const { data } = await this.$Http.api({
        url: 'webserver/v1/mobileShield/channels/{channelGid}/getBaseInfo',
        method: 'GET',
        params: {
          channelGid: this.$route.query.ditchID,
        },
      })

      this.appInfo = data
      this.logo = data.logoUrl
    },
    /**
     * 1：PC,H5,App 内专属门户页面打开次数
     * 2：成功注册用户数
     * 3：成功登录用户数
     * 4：成功实名认证用户数
     * */
    trackPage() {
      try {
        this.$tsignData.track('esignSheild_landing_initPage', {
          source: 'esign-sheild-isolate', // 渠道名称
          pageSource: this.$route.query.source || '',
          isFromRealName: (this.$route.query.serviceId && this.$route.query.verifycode && this.$route.query.passed) || '',
          url: window.location.href,
          ouid: this.user ? this.user.ouid : '',
        })
      } catch (e) {
        console.log('trackPage', e)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.bankeys {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  overflow: hidden;
  .main-wrapper {
    flex: 1;
    overflow: hidden;
    .scroll-content {
      width: 100%;
      height: 100%;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    }
  }
}
@media (max-width: 768px) {
  .bankeys {
    padding-bottom: 50px;
  }
}
</style>
<style lang="less">
// reset css
// 统一$confirm样式
.saas-auth-confirm {
  margin-top: 20px;
  line-height: 28px;
  color: #1a1a1a;
  font-size: 15px;
}
.saas-confirm {
  width: 440px;
  padding-bottom: 0;

  .el-message-box__header {
    padding: 18px 15px 18px;

    .el-message-box__title {
      font-size: 14px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }
  }

  .el-message-box__content {
    border-top: 1px solid #e4e4e4;
    border-bottom: 1px solid #e4e4e4;
    min-height: 125px;

    .el-message-box__message {
      padding-top: 12px;
    }
  }

  .el-message-box__btns {
    padding-top: 15px;
    padding-bottom: 15px;
  }

  &.icon-top .el-message-box__content .el-icon-warning {
    top: 21px;
    transform: translateY(0);
  }
}
button.el-button.btn-primary {
  background-color: #e61717;
  color: #ffffff;
  border: 0;
  &:hover {
    background: #e94949;
  }
  &.is-disabled,
  &.is-disabled:focus {
    background: rgba(230, 23, 23, 0.5);
    color: #ffffff;
  }
  @media (max-width: 750px) {
    border-radius: 0;
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.el-input-group__append {
  button.el-button.btn-primary {
    height: 32px;
    margin: -2px -20px;
    border-radius: 0;
    /* border: 1px solid #e61717; */
    display: flex;
    align-items: center;
  }
}
</style>
